import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelServiceBusSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelServiceBusSettingsEntity
